import React, { useEffect, useRef, useState } from 'react';
import Modal from "react-bootstrap/Modal";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";
import OrderPrint from '../../components/factoryOrder/OrderPrint';
import DeleteModal from "../../components/common/DeleteModal";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import RejectedModal from "../../components/common/RejectedModal";
import ErrorMessage from "../../components/common/ErrorMessage";
import { CheckNull } from "../../utils/Validate";
import { CreateEntry, DeleteEntry, GetList, GetListAsync, UpdateEntry } from "../../providers/dataProvider";
import FactoryOrderProductList from './FactoryOrderProductList';
import FactoryOrderProductSummary from './FactoryOrderProductSummary';
import FactoryOrderQuantityEntry from '../../components/factoryOrder/FactoryorderQuantityEntry/FactoryOrderQuantityEntry';
import Loader from '../../components/common/Loader';
import { ModalHeader } from 'react-bootstrap';

const FactoryOrderProduct = ({
    menuRights,
    values,
    currencyDetail,
    setValues,
    currencyList,
    setQuotUserEntry,
    quotUserEntry,
    handleSubmit,
    loading,
    orderProductsLoading,
    orderProductTab,
    setOrderProductTab,
    factoryReleaseRecordId,
    refreshFactoryOrderData,
    refreshFactoryOrderMarkData,
    activeMainTab,
    factoryOrderRecord,
    selectedOrder,
    releaseForm,
    isFactoryOrderEditMode,
    handleDeliveryFromDateChange,
    defaultCurrencyDetail,
    rejectedReleaseUpdated,
    onRejectedReleaseUpdated
}) => {
    const [orderProductCount, setOrderProductCount] = useState(0);
    const [rename, setRename] = useState(null);
    const [renameError, setRenameError] = useState(null);
    const [deleteShow, setDeleteShow] = useState({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false
    });
    const [actionMsg, setActionMsg] = useState(null);
    const [productionMsg, setProductionMsg] = useState(null);
    const [productionShow, setProductionShow] = useState(false);
    const [productionLoading, setProductionLoading] = useState(false);
    const [releaseRequestMsg, setReleaseRequestMsg] = useState(null);
    const [releaseRequestShow, setReleaseRequestShow] = useState(false);
    const [factoryApproval, setFactoryApproval] = useState(null);
    const [approvalDecisionMsg, setApprovalDecisionMsg] = useState(null);
    const [approvalSuccessShow, setApprovalSuccessShow] = useState(false);
    const [selectedApprovalDecision, setSelectedApprovalDecision] = useState("");
    const [approvalRemarks, setApprovalRemarks] = useState("");
    const [approvalRemarksError, setApprovalRemarksError] = useState("");
    const [showApprovalPopover, setShowApprovalPopover] = useState(false);
    const [showPendingPopover, setShowPendingPopover] = useState(false);
    const [pendingPopoverTarget, setPendingPopoverTarget] = useState(null);
    const generatedProductionBatchIds = useRef(new Set());
    const [errorShow, setErrorShow] = useState({
        show: false,
        errorMessage: "",
    });

    const EditOrderQuantity = (item) => {
        setOrderProductTab({ tab: "editorderquantity", data: item });
    };

    const getOrderProductId = (item) => item?.orderProductId || item?.id;

    const updateProducts = (updater) => {
        setValues((prev) => ({
            ...prev,
            products: updater(prev?.products || []),
        }));
    };

    const getProductKeys = (item) => [
        item?.customerOrderProductId,
        item?.quoteProductId,
        item?.orderProductId,
        item?.id,
    ].filter((value) => value !== null && value !== undefined && value !== "");

    const isSameProduct = (left, right) =>
        getProductKeys(left).some((leftKey) =>
            getProductKeys(right).some((rightKey) => String(leftKey) === String(rightKey))
        );

    const handleProductDeliveryDateChange = (date, product) => {
        updateProducts((products) =>
            products.map((item) =>
                isSameProduct(item, product)
                    ? {
                        ...item,
                        requestedDeliveryDate: date,
                        __requestedDeliveryDateChanged: true,
                        // Factory-order saves include both the mark and its
                        // product items. Keep their requested dates aligned so
                        // the edited date is not replaced by an older item date
                        // after the save refresh.
                        productItems: Array.isArray(item?.productItems)
                            ? item.productItems.map((productItem) => ({
                                ...productItem,
                                requestedDeliveryDate: date,
                            }))
                            : item?.productItems,
                    }
                    : item
            )
        );
    };

    const ProductRename = (item) => {
        if (!getOrderProductId(item)) return;
        setRename({ ...item });
        setRenameError(null);
    };

    const updateMarkName = () => {
        if (!rename) return;
        const markName = rename?.markName?.trim();
        if (!markName) {
            setRenameError("Name is required");
            return;
        }

        const orderProductId = getOrderProductId(rename);
        const updatedProduct = { ...rename, id: orderProductId, markName };
        setRenameError(null);
        updateProducts((products) =>
            products.map((product) =>
                getOrderProductId(product) === orderProductId
                    ? { ...product, markName }
                    : product
            )
        );
        UpdateEntry(
            "updateorderproductmark",
            updatedProduct,
            setActionMsg,
            "Mark Name updated successfully",
            "Failed to update markName"
        );
        setRename(null);
    };

    const HandleRenameKeyDown = (event) => {
        if (event.key === "Enter") updateMarkName();
    };

    const factoryReleaseId = factoryReleaseRecordId || factoryOrderRecord?.id;
    const userProfile = JSON.parse(localStorage.getItem("userProfile"));
    const currentIdentityId = userProfile?.identityId || localStorage.getItem("authidentity");
    const approvalData = factoryApproval?.data || factoryOrderRecord?.approval;
    const approvalStatus = String(approvalData?.status || "").toLowerCase();
    const isApprovalPending = approvalStatus === "pending";
    const isApprovalApproved = approvalStatus === "approved";
    const isApprovalRejected = approvalStatus === "rejected" || approvalStatus === "requiresresubmission";
    const isFactoryOrderReleased = isApprovalApproved;
    const factoryOrderStatus = String(factoryOrderRecord?.status ?? "").toLowerCase();
    const isLockedFactoryOrder = factoryOrderRecord?.isLockedForEdit === true && (
        Number(factoryOrderRecord?.status) === 1 ||
        Number(factoryOrderRecord?.status) === 3 ||
        factoryOrderStatus === "released" ||
        factoryOrderStatus === "pending approval" ||
        factoryOrderStatus === "pendingapproval"
    );
    const isLockedForPendingApproval = isLockedFactoryOrder && (
        Number(factoryOrderRecord?.status) === 3 ||
        factoryOrderStatus === "pending approval" ||
        factoryOrderStatus === "pendingapproval"
    );
    const submittedApprovalStatuses = ["Pending", "Approved"];
    const hasApprovalRequest = Boolean(
        approvalData?.approvalRequestId ||
        submittedApprovalStatuses.includes(approvalData?.status)
    );
    const currentStep = approvalData?.steps?.find(
        (step) => Number(step?.levelNo) === Number(approvalData?.currentLevelNo)
    );
    const isActionableForCurrentUser =
        isApprovalPending &&
        currentStep?.assignees?.some(
            (assignee) =>
                String(assignee?.approverIdentityId) === String(currentIdentityId) &&
                assignee?.status === "Pending"
        );

    const fetchFactoryApproval = () => {
        if (factoryReleaseId) {
            GetList("factoryPendingRequest", { id: factoryReleaseId }, setFactoryApproval);
        }
    };

    const formatDateTime = (date) => {
        if (!date) return "-";
        const parsedDate = new Date(`${date}${String(date).endsWith("Z") ? "" : "Z"}`);
        if (Number.isNaN(parsedDate.getTime())) return "-";

        return parsedDate.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const createEntryAsync = (resource, payload, successMessage, failureMessage) =>
        new Promise((resolve) => {
            CreateEntry(
                resource,
                payload,
                (response) => resolve(response),
                successMessage,
                failureMessage
            );
        });

    // The approval aggregate status is the server's final decision. In an
    // "AnyOne" workflow, other assignees can remain pending after one of them
    // approves, so their individual statuses must not prevent the release.
    const isApproved = (approval) =>
        String(approval?.status || "").toLowerCase() === "approved";

    const generateProductionBatch = async () => {
        setProductionLoading(true);
        const response = await createEntryAsync(
            "factoryrelease",
            { factoryReleaseId },
            "Production batch generated successfully",
            "Failed to generate production batch"
        );
        setProductionMsg(response);
        setProductionLoading(false);
    };

    const generateProductionBatchAfterFinalApproval = async (approval) => {
        const releaseKey = String(factoryReleaseId);
        if (!isApproved(approval) || generatedProductionBatchIds.current.has(releaseKey)) return;

        // Mark before the request so a repeated click or state refresh cannot
        // generate a second production batch for the same factory release.
        generatedProductionBatchIds.current.add(releaseKey);
        try {
            await generateProductionBatch();
        } catch (error) {
            setErrorShow({
                show: true,
                errorMessage: error?.message || "Failed to generate production batch",
            });
        }
    };

    const handleGenerateProduction = async () => {
        if (!factoryReleaseId || productionLoading) return;

        setProductionLoading(true);
        try {
            const approvalResponse = await createEntryAsync(
                "factoryApprovalRequest",
                { id: factoryReleaseId, remarks: "factoryOrder" },
                "Request submitted successfully",
                "Failed to submit request"
            );

            if (approvalResponse?.status !== 200) {
                setErrorShow({
                    show: true,
                    errorMessage: approvalResponse?.successData || approvalResponse?.message || "Failed to submit request",
                });
                return;
            }

            setReleaseRequestMsg(approvalResponse);
            setReleaseRequestShow(true);
            setFactoryApproval({ data: approvalResponse?.successData, message: "success" });
            fetchFactoryApproval();
            refreshFactoryOrderData && refreshFactoryOrderData(factoryReleaseId);
            window.dispatchEvent(new Event("approvalStatusChanged"));
        } catch (error) {
            setErrorShow({
                show: true,
                errorMessage: error?.message || "Failed to request factory order approval",
            });
        } finally {
            setProductionLoading(false);
        }
    };

    const handleApprovalDecision = async () => {
        if (!factoryReleaseId) return;

        const approve = selectedApprovalDecision === "approve";
        if (!approve && !approvalRemarks.trim()) {
            setApprovalRemarksError("Remarks are required");
            return;
        }

        const response = await createEntryAsync(
            "factoryApprovalDecision",
            {
                id: factoryReleaseId,
                isApproved: approve,
                remarks: approvalRemarks,
            },
            approve ? "Approved successfully" : "Rejected successfully",
            approve ? "Failed to approve" : "Failed to reject"
        );
        setApprovalDecisionMsg(response);

        // The approval-decision response carries the aggregate approval status.
        // Only its final Approved state (after the last approver) may generate.
        if (approve && response?.status === 200) {
            await generateProductionBatchAfterFinalApproval(response?.successData);
        }
        setApprovalRemarks("");
        setSelectedApprovalDecision("");
        setShowApprovalPopover(false);
    };

    const showPendingApprovalDetails = (event) => {
        setPendingPopoverTarget(event?.currentTarget || null);
        setShowPendingPopover(true);
        setShowApprovalPopover(false);
    };

    // const getApprovalStatusClass = (status) => {
    //     const normalized = String(status || "pending").toLowerCase();
    //     if (normalized === "approved") return "approval-status-approved";
    //     if (normalized === "rejected" || normalized === "requiresresubmission") return "approval-status-rejected";
    //     return "approval-status-pending";
    // };

    

    // const renderPendingApprovalDetails = () => (
    //     <div className={`pending ${getApprovalStatusClass(approvalData?.status)}`}>
    //         <div className="approved-wrapper">
    //             <div className="d-flex align-items-center gap-2">
    //                 <i className={`fas ${isApprovalApproved ? "fa-check" : "fa-exclamation-circle"} mr-2`}></i>
    //                 <h6>{approvalData?.status || "Pending"}</h6>
    //             </div>
    //             <hr />
    //             {(approvalData?.remarks || approvalData?.decisionRemarks) && (
    //                 <div className="mb-2">
    //                     <strong>Remarks</strong>
    //                     <p className="mb-0">{approvalData?.remarks || approvalData?.decisionRemarks}</p>
    //                 </div>
    //             )}
    //             {approvalData?.steps?.length ? approvalData.steps.map((step) => (
    //                 <div key={step?.id || step?.levelNo} className={`mt-2 approval-level ${getApprovalStatusClass(step?.status)}`}>
    //                     <strong className='mb-2'>Level {step?.levelNo} - <span>{step?.status}</span></strong>
    //                     {(step?.assignees || []).map((assignee) => (
    //                         <ol className={`c-timeline m-0 ${getApprovalStatusClass(step?.status)}`} key={assignee?.id || assignee?.approverIdentityId}>
    //                             <li className="c-timeline__item">
    //                                 <div className="c-timeline__content d-flex align-items-center" style={{paddingBottom: "1.1rem"}}>
    //                                     <i className="fas fa-user mr-2"></i>
    //                                     <p className="c-timeline__desc">{assignee?.approverName || "-"}</p>
    //                                 </div>
    //                             </li>
    //                             <li className="c-timeline__item">
    //                                 <div className="c-timeline__content d-flex align-items-center" style={{paddingBottom: "1.1rem"}}>
    //                                     <i className="fas fa-briefcase mr-2"></i>
    //                                     <p className="c-timeline__desc">{assignee?.approverRoleName || "-"}</p>
    //                                 </div>
    //                             </li>
    //                             <li className="c-timeline__item">
    //                                 <div className="c-timeline__content d-flex align-items-center" style={{paddingBottom: "1.1rem"}}>
    //                                     <i className="fas fa-clipboard mr-2"></i>
    //                                     <p className="c-timeline__desc">{assignee?.status || "-"}</p>
    //                                 </div>
    //                             </li>
    //                             {(assignee?.remarks || assignee?.decisionRemarks || step?.remarks || step?.decisionRemarks) && (
    //                                 <li className="c-timeline__item">
    //                                     <div className="c-timeline__content" style={{paddingBottom: "1.1rem"}}>
    //                                         <strong>Remarks</strong>
    //                                         <p className="c-timeline__desc mb-0">{assignee?.remarks || assignee?.decisionRemarks || step?.remarks || step?.decisionRemarks}</p>
    //                                     </div>
    //                                 </li>
    //                             )}
    //                         </ol>
    //                     ))}
    //                 </div>
    //             )) : (
    //                 <p className="approval-empty-message">No approvers found</p>
    //             )}
    //         </div>
    //     </div>
    // );

    const getApprovalStatusClass = (status) => {
    const normalized = String(status || "pending")
        .toLowerCase()
        .replace(/\s+/g, "");

    if (normalized === "approved") {
        return "approval-status-approved";
    }

    if (
        normalized === "rejected" ||
        normalized === "requiresresubmission"
    ) {
        return "approval-status-rejected";
    }

    return "approval-status-pending";
};

const renderPendingApprovalDetails = () => (
    <div className={`pending ${getApprovalStatusClass(approvalData?.status)}`}>
        <div className="approved-wrapper">

            <div className="d-flex align-items-center gap-2">
                <i
                    className={`fas ${
                        isApprovalApproved
                            ? "fa-check"
                            : "fa-exclamation-circle"
                    } mr-2`}
                ></i>

                <h6>{approvalData?.status || "Pending"}</h6>
            </div>

            <hr />

            {(approvalData?.remarks || approvalData?.decisionRemarks) && (
                <div className="mb-2">
                    <strong>Remarks</strong>
                    <p className="mb-0">
                        {approvalData?.remarks || approvalData?.decisionRemarks}
                    </p>
                </div>
            )}

            {approvalData?.steps?.length ? (
                approvalData.steps.map((step) => {

                    // Status of the current level
                    const levelStatusClass = getApprovalStatusClass(
                        step?.status
                    );

                    return (
                        <div
                            key={step?.id || step?.levelNo}
                            className={`mt-2 approval-level ${levelStatusClass}`}
                        >
                            <strong className="mb-2">
                                Level {step?.levelNo} -{" "}
                                <span>{step?.status || "Pending"}</span>
                            </strong>

                            {(step?.assignees || []).map((assignee) => {

                                // Status of the current approver
                                const assigneeStatusClass =
                                    getApprovalStatusClass(
                                        assignee?.status
                                    );

                                return (
                                    <ol
                                        className={`c-timeline m-0 ${assigneeStatusClass}`}
                                        key={
                                            assignee?.id ||
                                            assignee?.approverIdentityId
                                        }
                                    >
                                        <li className="c-timeline__item">
                                            <div
                                                className="c-timeline__content d-flex align-items-center"
                                                style={{
                                                    paddingBottom: "1.1rem"
                                                }}
                                            >
                                                <i className="fas fa-user mr-2"></i>
                                                <p className="c-timeline__desc">
                                                    {assignee?.approverName || "-"}
                                                </p>
                                            </div>
                                        </li>

                                        <li className="c-timeline__item">
                                            <div
                                                className="c-timeline__content d-flex align-items-center"
                                                style={{
                                                    paddingBottom: "1.1rem"
                                                }}
                                            >
                                                <i className="fas fa-briefcase mr-2"></i>
                                                <p className="c-timeline__desc">
                                                    {assignee?.approverRoleName || "-"}
                                                </p>
                                            </div>
                                        </li>

                                        <li className="c-timeline__item">
                                            <div
                                                className="c-timeline__content d-flex align-items-center"
                                                style={{
                                                    paddingBottom: "1.1rem"
                                                }}
                                            >
                                                <i className="fas fa-clipboard mr-2"></i>
                                                <p className="c-timeline__desc">
                                                    {assignee?.status || "Pending"}
                                                </p>
                                            </div>
                                        </li>

                                        {(assignee?.remarks ||
                                            assignee?.decisionRemarks ||
                                            step?.remarks ||
                                            step?.decisionRemarks) && (
                                            <li className="c-timeline__item">
                                                <div
                                                    className="c-timeline__content d-flex"
                                                    style={{
                                                        paddingBottom: "1.1rem"
                                                    }}
                                                >
                                                    <strong>Remarks</strong>

                                                    <p className="c-timeline__desc mb-0 ml-2">
                                                        - {assignee?.remarks ||
                                                            assignee?.decisionRemarks ||
                                                            step?.remarks ||
                                                            step?.decisionRemarks}
                                                    </p>
                                                </div>
                                            </li>
                                        )}
                                    </ol>
                                );
                            })}
                        </div>
                    );
                })
            ) : (
                <p className="approval-empty-message">
                    No approvers found
                </p>
            )}
        </div>
    </div>
);

    useEffect(() => {
        if (actionMsg?.message === "Mark duplicated successfully" && actionMsg?.successData?.id) {
            const duplicateId = actionMsg.successData.id;
            updateProducts((products) =>
                products.map((product, index) =>
                    typeof product?.id === "string" && product.id.indexOf("copy-") === 0 && index === products.length - 1
                        ? { ...actionMsg.successData, id: duplicateId }
                        : product
                )
            );
        }
    }, [actionMsg]);

    useEffect(() => {
        if (!productionMsg) return;

        const statusCode = productionMsg?.statusCode ?? productionMsg?.status;
        const isSuccess = statusCode === 200 || statusCode === 201 || statusCode === 204;

        setProductionLoading(false);
        if (isSuccess) {
            setProductionShow(true);
        }
    }, [productionMsg]);

    useEffect(() => {
        fetchFactoryApproval();
    }, [factoryReleaseId]);

    useEffect(() => {
        const refreshApprovalAfterDecision = async () => {
            if (CheckNull(approvalDecisionMsg?.message).includes("Failed")) {
            setErrorShow({
                show: true,
                errorMessage: approvalDecisionMsg?.successData,
            });
        } else if (CheckNull(approvalDecisionMsg?.status) == 200) {
            setApprovalSuccessShow(true);
            const approvalResponse = await GetListAsync("factoryPendingRequest", { id: factoryReleaseId });
            const updatedApproval = approvalResponse?.data;
            if (approvalResponse?.message === "success") {
                setFactoryApproval({ data: updatedApproval, message: "success" });
            } else {
                fetchFactoryApproval();
            }
            refreshFactoryOrderData && refreshFactoryOrderData(factoryReleaseId);
            window.dispatchEvent(new Event("approvalStatusChanged"));

        }
        };

        if (approvalDecisionMsg) refreshApprovalAfterDecision();
    }, [approvalDecisionMsg]);

    return (
        <div
            className={`tab-pane fade${activeMainTab === "order-summary" ? " show active" : ""}`}
            id="pills-order-summary"
            role="tabpanel"
            aria-labelledby="pills-order-summary-tab"
        >
            {orderProductTab.tab === "editorderquantity" ? (
               <FactoryOrderQuantityEntry
                        setOrderProductTab={setOrderProductTab}
                        values={values}
                        setValues={setValues}
                        orderProductTab={orderProductTab}
                        currencyDetail={currencyDetail}
                        factoryReleaseRecordId={factoryReleaseRecordId}
                        refreshFactoryOrderMarkData={refreshFactoryOrderMarkData}
                        refreshFactoryOrderData={refreshFactoryOrderData}
                        factoryOrderRecord={factoryOrderRecord}
                        releaseForm={releaseForm}
                        isFactoryOrderEditMode={isFactoryOrderEditMode}
                        isFactoryOrderReleased={isFactoryOrderReleased}
                        isFactoryOrderLocked={isLockedFactoryOrder}
                        isLockedForPendingApproval={isLockedForPendingApproval}
                        onRejectedReleaseUpdated={onRejectedReleaseUpdated}
                    />
            ) : (
                <>
                    <div className="row pt-1 product-configurations-row mt-2 order-product-manage">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="quote-product-actionbar order-product-actionbar">
                                <div>
                                    <span>Products</span>
                                    <strong>{orderProductCount} mark{orderProductCount === 1 ? "" : "s"}</strong>
                                </div>
                                <div className="d-flex flex-wrap">
                                    {currencyDetail?.shortCode && (
                                        <div className="quote-product-actionbar-currency mr-2">
                                            <span>Currency</span> : <strong>{currencyDetail.shortCode}</strong>
                                        </div>
                                    )}
                                    {isApprovalApproved ? (
                                    <div className="factory-order-btn">
                                        Factory order released
                                    </div>
                                    ) : isActionableForCurrentUser ? (
                                    <button
                                        type="button"
                                        className="btn btn-success btn-sm mr-2"
                                        onClick={() => {
                                            setSelectedApprovalDecision("");
                                            setApprovalRemarks("");
                                            setApprovalRemarksError("");
                                            setShowApprovalPopover(true);
                                            setShowPendingPopover(false);
                                        }}
                                    >
                                        Approve
                                    </button>
                                    ) : isApprovalPending ? (
                                    <button
                                        type="button"
                                        className="factory-order-btn"
                                        onClick={showPendingApprovalDetails}
                                    >
                                        Awaiting approval
                                    </button>
                                    ) : isApprovalRejected && !rejectedReleaseUpdated ? (
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={showPendingApprovalDetails}
                                    >
                                        Rejected
                                    </button>
                                    ) : (
                                    <div className="quote-product-actionbar-actions">
                                        {factoryReleaseId ? (
                                            <button
                                                type="button"
                                                className="btn update-btn"
                                                onClick={handleGenerateProduction}
                                                disabled={productionLoading}
                                                style={{color: '#fff', background: '#005795', borderColor: '#005795', height: '31px',borderRadius:'7px', padding: '3px', fontSize: '14px', width: '80px',marginRight:'7px'}}
                                            >
                                                {productionLoading ? "Generating..." : "Release"}
                                            </button>
                                        ) : null}
                                    </div>
                                    )}
                                    <div className="quote-product-actionbar-actions">
                                        {menuRights?.canPrint === true && (
                                            <OrderPrint
                                                values={{ ...values, id: factoryReleaseId, orderId: values?.id }}
                                                currencyDetail={currencyDetail}
                                            />                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="row quotation-summary-row order-summary-products-row">
                                <FactoryOrderProductList
                                    values={values}
                                    currencyDetail={currencyDetail}
                                    EditOrderQuantity={EditOrderQuantity}
                                    rename={rename}
                                    renameError={renameError}
                                    setOrderProductCount={setOrderProductCount}
                                    onRename={ProductRename}
                                    onRenameBlur={updateMarkName}
                                    onRenameChange={setRename}
                                    onRenameKeyDown={HandleRenameKeyDown}
                                    factoryOrderRecord={factoryOrderRecord}
                                    isFactoryOrderEdit={Boolean(factoryReleaseRecordId)}
                                     selectedOrder={selectedOrder}
                                    releaseForm={releaseForm}
                                    onProductDeliveryDateChange={handleProductDeliveryDateChange}
                                    approvalData={approvalData}
                                    showApprovalColumn={hasApprovalRequest}
                                    isFactoryOrderReleased={isFactoryOrderReleased}
                                    isActionableForCurrentUser={isActionableForCurrentUser}
                                    onActionableApproval={() => {
                                        setShowApprovalPopover(true);
                                        setShowPendingPopover(false);
                                    }}
                                    onApprovalIndicator={showPendingApprovalDetails}
                                />
                                <FactoryOrderProductSummary
                                    values={values}
                                    setValues={setValues}
                                    currencyDetail={currencyDetail}
                                    setQuotUserEntry={setQuotUserEntry}
                                    defaultCurrencyDetail={defaultCurrencyDetail}
                                    quotUserEntry={quotUserEntry}
                                    factoryOrderRecord={factoryOrderRecord}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )}
            <SaveSuccessModel
                show={productionShow}
                createMsg={productionMsg}
                setShow={setProductionShow}
                SuccessDoneClick={() => setProductionShow(false)}
            />
            {approvalDecisionMsg?.message === "Rejected successfully" ? (
                <RejectedModal
                    show={approvalSuccessShow}
                    createMsg={approvalDecisionMsg}
                    setShow={setApprovalSuccessShow}
                    SuccessDoneClick={() => setApprovalSuccessShow(false)}
                />
            ) : (
            <>
                <SaveSuccessModel
                show={releaseRequestShow}
                createMsg={releaseRequestMsg}
                setShow={setReleaseRequestShow}
                SuccessDoneClick={() => setReleaseRequestShow(false)}
            />
            <SaveSuccessModel
                    show={approvalSuccessShow}
                    createMsg={approvalDecisionMsg}
                    setShow={setApprovalSuccessShow}
                    SuccessDoneClick={() => setApprovalSuccessShow(false)}
                />
            </>
            )}
            <ErrorMessage
                Show={errorShow?.show}
                errorMessage={errorShow?.errorMessage}
                ErrorDoneClick={() => setErrorShow({ show: false, errorMessage: "" })}
            />
            {orderProductsLoading && <Loader />}
            <Modal
                show={showApprovalPopover}
                onHide={() => {
                    setShowApprovalPopover(false);
                    setSelectedApprovalDecision("");
                    setApprovalRemarks("");
                    setApprovalRemarksError("");
                }}
                centered
                className="approvalLevelsModal"
            >
                <ModalHeader>
                    <h3>Factory Order Approval</h3>
                    <button
                        type="button"
                        className="approval-modal-close"
                        aria-label="Close"
                        onClick={() => {
                            setShowApprovalPopover(false);
                            setSelectedApprovalDecision("");
                            setApprovalRemarks("");
                            setApprovalRemarksError("");
                        }}
                    >
                        &times;
                    </button>
                </ModalHeader>
                <Modal.Body>
                    <div className="approve-popover">
                        <label htmlFor="factory-order-approval-decision">Decision</label>
                        <select
                            id="factory-order-approval-decision"
                            className="form-control"
                            value={selectedApprovalDecision}
                            onChange={(event) => {
                                setSelectedApprovalDecision(event.target.value);
                                setApprovalRemarks("");
                                setApprovalRemarksError("");
                            }}
                        >
                            <option value="">Select an approval decision</option>
                            <option value="approve">Approve</option>
                            <option value="reject">Reject</option>
                        </select>
                        {selectedApprovalDecision && (
                            <>
                                <label className="mt-2" htmlFor="factory-order-approval-remarks">
                                    Remarks{selectedApprovalDecision === "reject" ? " *" : ""}
                                </label>
                                <textarea
                                    id="factory-order-approval-remarks"
                                    rows={4}
                                    className="form-control mb-2"
                                    placeholder="Enter your remarks here"
                                    value={approvalRemarks}
                                    aria-invalid={Boolean(approvalRemarksError)}
                                    onChange={(e) => {
                                        setApprovalRemarks(e.target.value);
                                        if (approvalRemarksError) setApprovalRemarksError("");
                                    }}
                                />
                                {approvalRemarksError && <p className="form-error mb-0">{approvalRemarksError}</p>}
                                <div className="mt-3 d-flex justify-content-end">
                                    <button
                                        className="btn btn-sm btn-secondary w-100 mr-2"
                                        onClick={() => {
                                            setSelectedApprovalDecision("");
                                            setApprovalRemarks("");
                                            setApprovalRemarksError("");
                                            setShowApprovalPopover(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className={`btn btn-sm w-100 ${selectedApprovalDecision === "approve" ? "save-btn" : "save-btn"}`}
                                        onClick={handleApprovalDecision}
                                    >
                                        Save
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
            <Overlay
                show={showPendingPopover}
                onHide={() => setShowPendingPopover(false)}
                target={pendingPopoverTarget}
                placement="bottom-end"
                rootClose
            >
                <Popover className="factory-approval-callout">
                    <Popover.Body>{renderPendingApprovalDetails()}</Popover.Body>
                </Popover>
            </Overlay>
        </div>
    );
};

export default FactoryOrderProduct;
